import { MatDialogRef, MAT_DIALOG_DATA, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { LocaleComponent } from '../Locale/locale.component';


@Component({
    standalone: true,
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'iOSPopupModal',
    template: `
      <mat-dialog-content>
           <app-locale localeKey="{{key}}" localeView="{{view}}" ></app-locale>
      </mat-dialog-content>
      <mat-dialog-actions>
          <button type="button" class="btn btn-default" (click)="onClose()">
              <app-locale localeKey="CLOSE_BTN_LABEL" localeView="IFRAME" ></app-locale>
          </button>
      </mat-dialog-actions>
        `,
    imports: [CdkScrollable, MatDialogContent, LocaleComponent, MatDialogActions]
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class iOSPopupModal {
    key: string;
    view: string;
    constructor(
        public dialogRef: MatDialogRef<iOSPopupModal>,
        @Inject(MAT_DIALOG_DATA) public data: any) { this.key = data.key; this.view = data.view}

    onClose(): void {
        this.dialogRef.close();
    }
}
